import React from 'react';

import {
	useRedactionsTour,
	RedactionsTourSteps,
} from '@confluence/redactions/entry-points/tour.ts';

import {
	useMoreActionsObjectSidebarTour,
	MoreActionsObjectSidebarTourSteps,
} from './useMoreActionsObjectSidebarTour.tsx';

type ObjectSidebarSpotlightTourProps = {
	contentId: string;
};

export const ObjectSidebarSpotlightTour = React.memo(
	({ contentId }: ObjectSidebarSpotlightTourProps) => {
		const { activeSpotlight: activeMoreActionsObjectSidebarTourSpotlight } =
			useMoreActionsObjectSidebarTour({
				step: MoreActionsObjectSidebarTourSteps.FIRST,
			});

		const { activeSpotlight: activeRedactionsTourSpotlight } = useRedactionsTour({
			contentId,
			step: RedactionsTourSteps.SECOND,
		});

		// Note: Redactions tour shouldn't trigger anyway, if either of this "primary" tour is active
		return activeMoreActionsObjectSidebarTourSpotlight ?? activeRedactionsTourSpotlight;
	},
);
